import { useReduxStore } from '../../../../custom-hooks';
import Component from './Component';

function VotersInfo(props) {
    const { commonReducer } = useReduxStore();
    return <Component {...props} votersDetails={commonReducer.modal.votersInfo}/>;
}

export default VotersInfo;
